import { render, staticRenderFns } from "./ShopResetPassword.vue?vue&type=template&id=788c0ebb&"
import script from "./ShopResetPassword.vue?vue&type=script&lang=js&"
export * from "./ShopResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ShopResetPassword.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports